// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.betriebsmittel-aktueller-ort {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.betriebsmittel-aktueller-ort ion-badge {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/betriebsmittel-aktueller-ort/betriebsmittel-aktueller-ort.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AACF;AACE;EACE,UAAA;AACJ","sourcesContent":[".betriebsmittel-aktueller-ort {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n\n  ion-badge {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
